import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { FooterColumnCms } from '~/cms/interfaces/footer.cms.interface';
import { CmsService } from '~/cms/services/cms/cms.service';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';

@Component({
  selector: 'app-attendee-footer',
  templateUrl: './footer.component.html',
})
export class AttendeeFooterComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  public readonly logoActivityPro = LogoTypeEnum.OrganizerDark;

  public columns: FooterColumnCms[] = [];
  public description: string;
  public logo = LogoTypeEnum.OrganizerLight;
  public title: string;

  constructor(private readonly cmsService: CmsService) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.cmsService.getFooter().subscribe((footer) => {
        this.title = footer.info_block?.title;
        this.description = footer.info_block?.description;
        this.columns = [
          footer.footer_column_1,
          footer.footer_column_2,
          footer.footer_column_3,
        ];
      })
    );
  }
}
